import { ChevronDownIcon } from "@heroicons/react/20/solid";
// import { SessionAvatar } from "./session-avatar";
import { SessionAvatarUseClient } from "./session-avatar-use-client";

import { useSession } from "next-auth/react";

export function SessionAvatarAndNameUseClient({ size = 8 }: { size?: number }) {
  const session = useSession();
  return (
    <>
      <SessionAvatarUseClient size={size} />
      {/* <img
          className="h-8 w-8 rounded-full bg-gray-50"
          src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
          alt=""
        /> */}
      <span className="hidden lg:flex lg:items-center">
        <span className="ml-4 text-sm font-semibold leading-6 text-gray-900" aria-hidden="true">
          {session.data?.user?.name}
        </span>
        <ChevronDownIcon className="ml-2 h-5 w-5 text-gray-400" aria-hidden="true" />
      </span>
    </>
  );
}
